import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddUserLayer from "../components/AddUserLayer";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from 'react-select'
import { useParams } from "react-router-dom";
import { API_URL } from "..";
const ScheduleIssueMaintenance = () => {
    const {id} = useParams();
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [sendNotification, setSendNotification] = useState(false);
  const [showAlertMessage, setshowAlertMessage] = useState({
    status:false,
    message:'',
    desc:''
  });
  
  const [phone, setPhone] = useState("");
  const [selectTruck, setSelectTruck] = useState({});
  const [truckList, setTruckList] = useState([]);

  const handleChangeTruck = (selected) => {
    setSelectTruck(selected || []);
  };
  const [jobsData , setJobData] = useState([])
 
React.useEffect(()=>{
  
  fetchSingleMaintenance()
},[1])

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
    
  };
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  const fetchSingleMaintenance = async () =>{
    const user = JSON.parse(localStorage.getItem('user'));
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }

       let response = await fetch(API_URL+`/api/maintenance/issue/single-record/${id}`, { 
         method: "GET",
         headers: headersList
       });
       let data = await response.json();
       setJobData(data)
       setSelectTruck({label:data.driver.truck.name, value:data.driver.truck.id})
      
}
  const onFormSubmit = async (event) =>{
      const user = JSON.parse(localStorage.getItem('user'))
      event.preventDefault();

      let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
         
         let bodyContent = JSON.stringify({
            "truck_id":selectTruck.value,
           "issue_description": event.target.elements.maintenance_description.value,
           "service_date": event.target.elements.maintenance_date.value,
           "cost": event.target.elements.service_cost.value,
           "poc_number":phone
    
         });
         let response = await fetch(API_URL+`/api/maintenance/create/issue/${user.id}/${id}`, {
           method: "POST",
           body: bodyContent,
           headers: headersList
         });
       let data = await response.json();
       if(response.status == 201){
        setshowAlertMessage({
          message: 'success',
          status:true,
          desc:'Maintenance Schedule Is added successfully'
        });
        setSelectTruck({})
        setPhone('')
        event.target.elements.maintenance_description.value=''
        event.target.elements.maintenance_date.value=''
        event.target.elements.service_cost.value=''
       }else{
        setshowAlertMessage({
          message: 'error',
          status:true,
          desc:'Error while adding new schedule'
        });
       }
    
     
  }

  const formatPhoneNumber = (value) => {
    // Remove all non-digit characters
    const cleaned = value.replace(/\D/g, "");
  
    // Format the number as (XXX) XXX-XXXX
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
  
    if (!match) return value;
  
    const formatted = [
      match[1] && `(${match[1]}`,
      match[2] && `) ${match[2]}`,
      match[3] && `-${match[3]}`,
    ]
      .filter(Boolean)
      .join("");
  
    return formatted;
  };
  const handleInputChange = (e) => {
    const formattedPhone = formatPhoneNumber(e.target.value);
    setPhone(formattedPhone);
  };

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Schedule Maintenance" />

        {/* AddUserLayer */}
        <div className="card h-100 p-0 radius-12">
          <div className="card-body p-24">
            <div className="row justify-content-center">
              <div className="col-xxl-6 col-xl-8 col-lg-10">
                <div className="card border">
                  <div className="card-body">
                   
                    {/* Upload Image Start */}

                    {/* Upload Image End */}
                    <form onSubmit={(event)=>onFormSubmit(event)}>
                    

                      <div className="mb-20">
                        <label
                          htmlFor="assigned_to"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Select Truck
                          <span className="text-danger-600">*</span>{" "}
                        </label>
                        <Select
                            options={truckList}
                            value={selectTruck}
                            isDisabled={true}
                            onChange={handleChangeTruck}
                            placeholder="Select Options"
                        />
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                         Select Maintenance Date
                        </label>
                        <input
                          type="date"
                          
                          name="maintenance_date"
                          className="form-control radius-8"
                          id="maintenance_date"
                          placeholder="Select the date"
                        />
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Phone (Optional)  <i style={{fontSize:20,marginTop:10}} title="Person phone number to be contact" className="ph ph-info"></i>
                        </label>
                        <input
                          type="tel"
                          name="phone"
                          className="form-control radius-8"
                          id="phone"
                          value={phone}
                          onChange={handleInputChange}
                          placeholder="Phone Number"
                        />
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="password"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                         Cost
                        </label>
                        <input
                          type="text"
                          name="service_cost"
                          className="form-control radius-8"
                          id="service_cost"
                          
                          placeholder="0.00"
                        />
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Maintenance Description
                        </label>
                        <textarea
                          type="text"
                          name="maintenance_description"
                          className="form-control radius-8"
                          id="maintenance_description"
                          placeholder="Description...."
                        />
                      </div>
                      <div className="form-switch switch-success d-flex align-items-center gap-3 mb-40 mt-40">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="switch1"
                                name="notification_send"
                                onChange={(e)=>setSendNotification(!sendNotification)}
                                defaultChecked={sendNotification}
                            />
                            <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="switch1"
                            >
                                Send notification to associate driver
                            </label>
                        </div>
                    
                      {
                      showAlertMessage.status === true?
                    <div
                        className={
                          showAlertMessage.message == 'error' ?
                          "alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10":
                          "alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                        }
                        role="alert"
                    >
                        {showAlertMessage.desc}
                        <button type="button" onClick={()=>setshowAlertMessage(!showAlertMessage)} className="remove-button text-secondary-600 text-xxl line-height-1">
                            {" "}
                            <Icon icon="iconamoon:sign-times-light" className="icon" />
                        </button>
                    </div>:null
                    }
                   
                      <div className="d-flex align-items-center justify-content-center gap-3">
                   
                        <button
                          type="submit"
                          className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default ScheduleIssueMaintenance;
